(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.accessibility = {
    attach: function (context, settings) {
      $('body', context).once('accessibility').each(function () {
        function handleFirstTab(e) {
          if (e.keyCode === 9) {
            document.body.classList.add('user-is-tabbing');

            window.removeEventListener('keydown', handleFirstTab);
            window.addEventListener('mousedown', handleMouseDownOnce);
          }
        }

        function handleMouseDownOnce() {
          document.body.classList.remove('user-is-tabbing');

          window.removeEventListener('mousedown', handleMouseDownOnce);
          window.addEventListener('keydown', handleFirstTab);
        }

        window.addEventListener('keydown', handleFirstTab);

      });
    }
  }
})(jQuery, Drupal, drupalSettings);
